export default __webpack_public_path__ + "40c1a815516f56754df1501ff24ff7b6.png";